import { Box, Typography } from "@mui/material";

const WatchStage = () => {
  return (
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: 3,
        px: 4,
        textAlign: "center",
      }}
    >
      <Typography variant="h4" fontWeight={700}>
        Watch the stage
      </Typography>
      <Typography color="textSecondary">
        Keep this screen open. It will change on its own when it is your turn.
      </Typography>
    </Box>
  );
};

export default WatchStage;
